<template>
    <modal @close="onClose" ref="modal">
        <template v-slot:title>Add a passkey</template>

        <slot>
            <form-errors :errors="formErrors"/>

            <form @submit.prevent="onContinue" novalidate class="mui-form" data-test="passkey-name">
                <p>Name this passkey so you can tell it apart later. Your browser will then ask you to create it.</p>
                <form-input v-model="formData.name" :errors="errors.name" label="Name" placeholder="e.g. MacBook, iPhone, 1Password" type="text" maxlength="100" :nocaps="true" />
                <button-row>
                    <button type="button" class="btn btn-outline-primary" @click.prevent="close">Cancel</button>
                    <button type="submit" class="btn btn-primary" :disabled="busy">Continue</button>
                </button-row>
            </form>
        </slot>
    </modal>
</template>

<script>
import { startRegistration } from '@simplewebauthn/browser'
import api from '@/api'
import bus from '@/bus'
import ModalMixin from '@/mixins/ModalMixin'
import FormMixin from '@/mixins/Form'
import { report } from './mfaHelpers'

const BASE = '/account/mfa'

export default {
    mixins: [ModalMixin, FormMixin],
    props: {
        guard: {type: Function, required: true},
    },
    emits: ['added', 'close'],
    data() {
        return {
            busy: false,
            formData: this.makeFormData(),
        }
    },
    methods: {
        makeFormData() {
            return {name: ''}
        },
        onClose() {
            this.busy = false
            this.errors = {}
            this.formErrors = []
            this.formData = this.makeFormData()
            this.$emit('close')
        },
        // Each API call goes through guard so a re-verify can retry it; the
        // browser prompt itself is never repeated
        onContinue() {
            if (this.busy) {
                return
            }
            this.busy = true
            this.formErrors = []
            const name = this.formData.name.trim()
            this.guard(() => api.post(`${BASE}/passkeys/begin`, {})).then((optionsJSON) => {
                return startRegistration({optionsJSON})
            }).then((credential) => {
                return this.guard(() => api.post(`${BASE}/passkeys/finish`, {credential, name}))
            }).then((resp) => {
                this.busy = false
                bus.showInfo('Passkey added.')
                this.$emit('added', resp)
                this.close()
            }).catch((err) => {
                this.busy = false
                if (err && err.cancelled) {
                    return
                }
                // Cancelling the browser prompt rejects with a DOMException
                if (!err || !err.__status__) {
                    this.formErrors = ["That passkey wasn't added. Try again or use another method."]
                    return
                }
                this.formErrors = err.__all__ || []
                report(err)
            })
        },
    },
}
</script>
